// extracted by mini-css-extract-plugin
module.exports = {"sliderTitle":"Logs_sliderTitle__1S3r0","logList":"Logs_logList__1LGb_"};